import { render } from "./Renovacion01Plan.vue?vue&type=template&id=36e150b3&scoped=true"
import script from "./Renovacion01Plan.vue?vue&type=script&lang=js"
export * from "./Renovacion01Plan.vue?vue&type=script&lang=js"

import "@/assets/css/tarjetas.css?vue&type=style&index=0&id=36e150b3&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e150b3"]])

export default __exports__